/// <reference path="../../../tools/typings/tsd.d.ts"/>

namespace DealerwareWebComponents {
    "use strict";

    export interface IDealerwareController  {
        // Properties
        //-------------------------------------------

        // Methods
        //-------------------------------------------
    }
}